import { z } from '@/lib/zod'

export const FilterApplicationsSchema = () =>
  z.object({
    freeSearch: z.string().nullable().optional(),
    tag: z.string().nullable().optional(),
    requiresApiUser: z.boolean().nullable().optional(),
    requiresEntityAccount: z.boolean().nullable().optional(),
    isActive: z.boolean().nullable().optional().default(false),
  })

export type FilterApplicationsForm = z.infer<
  ReturnType<typeof FilterApplicationsSchema>
>
